import React, { useEffect, useState } from "react";
import { Mail, MessageCircle, Trash2, CheckCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const STATUS_COLORS = {
  new: "bg-[#D4AF37]/15 text-[#0A1128] border-[#D4AF37]",
  read: "bg-blue-50 text-blue-700 border-blue-200",
  replied: "bg-green-50 text-green-700 border-green-200",
  closed: "bg-slate-100 text-slate-500 border-slate-200",
};

const AdminInquiries = () => {
  const [items, setItems] = useState([]);

  const load = () => api.get("/inquiries").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/inquiries/${id}`, { status });
    toast.success("Updated");
    load();
  };

  const remove = async (id) => {
    if (!confirm("Delete?")) return;
    await api.delete(`/inquiries/${id}`);
    load();
  };

  return (
    <div data-testid="admin-inquiries">
      <h1 className="font-display text-3xl text-[#0A1128] mb-8">Inquiries / RFQs</h1>
      {items.length === 0 ? (
        <p className="text-slate-500">No inquiries yet.</p>
      ) : (
        <div className="space-y-4">
          {items.map((i) => (
            <div key={i.id} className="bg-white border border-slate-200 rounded-sm p-6" data-testid={`inquiry-${i.id}`}>
              <div className="flex flex-wrap justify-between items-start gap-4 mb-4">
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <h3 className="font-display text-xl text-[#0A1128]">{i.name}</h3>
                    <span className={`text-[10px] px-2 py-1 rounded-sm uppercase tracking-[0.15em] border ${STATUS_COLORS[i.status] || ""}`}>{i.status}</span>
                  </div>
                  <p className="text-xs text-slate-500">{i.company} {i.country && `• ${i.country}`} • {new Date(i.created_at).toLocaleString()}</p>
                </div>
                <div className="flex items-center gap-2">
                  <a href={`mailto:${i.email}`} className="p-2 border border-slate-200 hover:border-[#D4AF37] rounded-sm" title="Email"><Mail size={14} /></a>
                  {i.whatsapp && <a href={`https://wa.me/${i.whatsapp.replace(/\D/g,'')}`} target="_blank" rel="noopener noreferrer" className="p-2 border border-slate-200 hover:border-[#D4AF37] rounded-sm" title="WhatsApp"><MessageCircle size={14} /></a>}
                  <select value={i.status} onChange={(e) => setStatus(i.id, e.target.value)} data-testid={`inquiry-status-${i.id}`} className="text-xs uppercase tracking-[0.15em] border border-slate-300 px-3 py-2 rounded-sm">
                    <option value="new">New</option>
                    <option value="read">Read</option>
                    <option value="replied">Replied</option>
                    <option value="closed">Closed</option>
                  </select>
                  <button onClick={() => remove(i.id)} data-testid={`inquiry-del-${i.id}`} className="p-2 text-slate-400 hover:text-red-500"><Trash2 size={14} /></button>
                </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm mb-4">
                <Field l="Email" v={i.email} />
                <Field l="WhatsApp" v={i.whatsapp} />
                <Field l="Interest" v={i.interest} />
                <Field l="Quantity" v={i.quantity} />
                <Field l="Destination" v={i.destination} />
              </div>
              {i.message && <p className="text-sm text-slate-700 bg-slate-50 p-4 rounded-sm whitespace-pre-line">{i.message}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Field = ({ l, v }) => (
  <div>
    <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">{l}</div>
    <div className="text-[#0A1128]">{v || "—"}</div>
  </div>
);

export default AdminInquiries;
